export default "__VITE_ASSET__BTt3aXuQ__"